<template>
  <svg class="front" :height="radius * 2" :width="radius * 2">
    <circle
      :stroke="baseRingColor"
      :stroke-width="stroke"
      :r="normalizedRadius"
      :cx="radius"
      :cy="radius"
    />
    <circle
      :stroke="strokeColor"
      :stroke-dasharray="circumference + ' ' + circumference"
      :style="{ strokeDashoffset }"
      :stroke-width="stroke"
      :r="normalizedRadius"
      :fill="fillColor"
      :cx="radius"
      :cy="radius"
    />
  </svg>
</template>

<script>
export default {
  props: {
    // The size of the circle radius in pixels
    radius: {
      type: Number,
      default: null,
    },
    // The progress to display (an absolute number)
    progress: {
      type: Number,
      default: null,
    },
    // The maximum progress (a number for 100% progress)
    progressLimit: {
      type: Number,
      default: 0,
    },
    // The stroke size
    stroke: {
      type: Number,
      default: null,
    },
    // The fill color for the circle
    fillColor: {
      type: String,
      default: 'transparent',
    },
    // The stroke color
    strokeColor: {
      type: String,
      default: 'white',
    },
    // The ring color without the stroke
    baseRingColor: {
      type: String,
      default: 'white',
    },
  },

  data() {
    const normalizedRadius = this.radius - this.stroke * 2;
    const circumference = normalizedRadius * 2 * Math.PI;

    return {
      normalizedRadius,
      circumference,
    };
  },

  computed: {
    strokeDashoffset() {
      const progressPercentage = this.progress / this.progressLimit;
      return this.circumference - progressPercentage * this.circumference;
    },
  },
};
</script>

<style lang="scss" scoped>
circle {
  transform: rotate(-90deg);
  transform-origin: 50% 50%;
}
</style>
